import { Route, Routes } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import DrawerMIC from "../../../common/components/DrawerMIC";
import { checkForfaitApi } from "../../../common/services/api/DfdApi";
import routesConfig from "../../../common/utils/routesConfig";

function Home({ roles, token }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      return undefined;
    }

    let isMounted = true;
    setLoading(true);

    checkForfaitApi(token)
      .then((response) => {
        if (!isMounted) {
          return;
        }

        localStorage.setItem("suspend", response?.data?.body?.suspend);
        localStorage.setItem("valide", response?.data?.body?.valide);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        if (isMounted) {
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [token]);

  const ProtectedRoutes = ({ userRoles }) => {
    return (
      <Routes>
        {routesConfig.map((route, index) => {
          if (route.roles.some((role) => userRoles.includes(role))) {
            return (
              <Route
                key={index}
                path={route.path}
                element={<route.component {...route.props} />}
              />
            );
          }
          return null;
        })}
      </Routes>
    );
  };

  return (
    localStorage.getItem("token") && (
      <>
        {loading ? (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.5)",
              zIndex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <DrawerMIC content={<ProtectedRoutes userRoles={roles} />} />
        )}
      </>
    )
  );
}

export default Home;
